import { fromJS } from 'immutable';

import {
  newToastMessageType,
  removeToastMessageType,
  setRemovingToastMessageType,
  updateToastMessageType,
} from './ToastMessagesConstants';

import { removingAllPoorNetToastMessagesType } from './PoorNetToastMessage/PoorNetToastMessageActions';


export const initialState = fromJS({
  messagesRightTop: [],
});

function findMessageById (messages, messageId) {
  return messages.findIndex(
    (data) => {
      const { id } = data;

      return id === messageId;
    }
  );
}

function updateMessageById (messages, messageId, updatFn) {
  const index = findMessageById(messages, messageId);

  if (index === -1) {
    return messages;
  }

  return messages.update(
    index,
    updatFn,
  );
}

export default function toastMessagesReducer (state = initialState, action) {
  switch(action.type) {

    case newToastMessageType: {
      const { data } = action;

      return state.update('messagesRightTop', (messages) => {
        return messages.unshift(data);
      });
    }

    case setRemovingToastMessageType: {
      const { id } = action;

      return state.update('messagesRightTop', (messagesRightTop) => {
        return updateMessageById(messagesRightTop, id, (message) => {
          return { ...message, removingInProgress: true };
        });
      });
    }

    case updateToastMessageType: {
      const { id, data } = action;

      return state.update('messagesRightTop', (messagesRightTop) => {
        return updateMessageById(messagesRightTop, id, (message) => {
          return { ...message, ...data };
        });
      });
    }

    case removeToastMessageType: {
      const { id } = action;

      return state.update('messagesRightTop', (messagesRightTop) => {
        const index = findMessageById(messagesRightTop, id);

        return messagesRightTop.delete(index);
      });
    }

    case removingAllPoorNetToastMessagesType: {

      return state.update('messagesRightTop', (messagesRightTop) => {
        return messagesRightTop.map((message) => {
          const { poorNetworkConnection } = message;
          if (poorNetworkConnection) {
            return { ...message, removingInProgress: true };
          }

          return message;
        });
      });
    }

    default: {
      return state;
    }
  }
}
